import Carousel from "../components/Carousel";
import Map from "../components/Map";

function Home() {
  return (
    <main>
      <section className="welcome-card">
        <h1>Welcome Inn</h1>
        </section>

      <Carousel />

      <section className="about">
        <h2>About Us</h2>
        <p>
        Welcome Inn Motel is your home away from home in St. Mary’s, Georgia. Nestled just minutes from the scenic waterfront and historic downtown, 
        our family-owned property combines the charm of small-town hospitality with all the modern comforts you need for a relaxing stay. Whether 
        you’re here for business, leisure, or a quick stopover, you’ll find clean, comfortably furnished rooms, friendly service, and unbeatable value.
        </p>
        
      </section>

      <section className="contact">
        <h2>Contact Us</h2>
        <p><strong>Phone:</strong> (912) 275-5000</p>
        <p>
          <strong>Email: </strong> 
          <a className="email-link" href="mailto:welcomeinn1921@gmail.com">welcomeinn1921@gmail.com</a>
        </p>

      </section>

      <Map />
    </main>
  );
}

export default Home;
